import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rich_houtui",
  "use": "icon-rich_houtui-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rich_houtui\">\n    <path d=\"M7 14.5C6.72386 14.5 6.5 14.7239 6.5 15C6.5 15.2761 6.72386 15.5 7 15.5V15V14.5ZM0 5L5 7.88675V2.11325L0 5ZM11 15V14.5H7V15V15.5H11V15ZM4.5 5V5.5H11V5V4.5H4.5V5ZM16 10H15.5C15.5 12.4853 13.4853 14.5 11 14.5V15V15.5C14.0376 15.5 16.5 13.0376 16.5 10H16ZM16 10H16.5C16.5 6.96243 14.0376 4.5 11 4.5V5V5.5C13.4853 5.5 15.5 7.51472 15.5 10H16Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol